import React from 'react'
import classNames from 'classnames'
import { usePageContext } from '@toasttab/shared/src/hooks/usePageContext'
import VidyardPlayButton from '@toasttab/shared/src/components/molecules/VidyardPlayButton/VidyardPlayButton'
import { VideoProps } from './Video.d'
import Image from '@toasttab/shared/src/components/atoms/Image/Image'
import VidyardVideoPlayer from '@toasttab/shared/src/components/molecules/VidyardVideo/VidyardVideoPlayer'
import VideoAnimation from '../VideoAnimation/VideoAnimation'

const Video = ({
  classes,
  heapInteraction,
  image,
  labelOutside,
  playButtonClasses,
  imageClasses,
  inverseButton = false,
  sectionHeading,
  vidyardId,
  numComponents = 1
}: VideoProps) => {
  const pageContext = usePageContext()
  const handleClick = () => {
    if (typeof window !== 'undefined') {
      const vidyardEmbed = require('@vidyard/embed-code')
      // @ts-ignore - Typescript doesn't like setting new properties on window
      let players = vidyardEmbed.api.getPlayersByUUID(vidyardId)
      if (players && players.length > 0) {
        const index = players.findIndex((player: any) =>
          player.hasOwnProperty('showLightbox')
        )
        players[index].showLightbox()
      }
    }
  }

  const wrapperCss = classNames(
    classes,
    'ds-video flex-wrap items-center justify-center relative',
    {
      'content-center inline-flex': !image,
      flex: image
    }
  )
  let buttonClass = `${
    pageContext.styleContext !== 'hpVariant' ? 'absolute z-[1]' : ''
  }`

  const playClasses = classNames(playButtonClasses, buttonClass)

  const previewMp4 = image?.[0]?.url?.split('.').pop() === 'mp4'

  const buttonVariation = inverseButton ? 'inverse-primary' : 'blue-primary'

  return (
    <div
      className={wrapperCss}
      data-testid={`video${numComponents ? `-${numComponents}` : ''}`}
    >
      {labelOutside ? (
        <div className='flex items-center justify-center'>
          <VidyardPlayButton
            classes={playClasses}
            variation={image ? buttonVariation : 'blue'}
            onClick={handleClick}
            size='large'
          />
          <span className='text-secondary'>{sectionHeading}</span>
        </div>
      ) : (
        <VidyardPlayButton
          classes={playClasses}
          interactionId={heapInteraction}
          variation={image ? buttonVariation : 'blue'}
          label={sectionHeading}
          onClick={handleClick}
          size='large'
        />
      )}
      {image && (
        <>
          {previewMp4 ? (
            <VideoAnimation
              animation={{ url: image[0].url }}
              autoPlay
              classes={imageClasses ? imageClasses : 'rounded-lg'}
              loop
            />
          ) : (
            <Image
              imgClasses={imageClasses}
              classes=''
              url={image[0].url}
              optimizedImages={image[0].optimizedImages}
              lazyLoad={image[0].lazyLoad}
            />
          )}
        </>
      )}
      <div className='hidden'>
        <VidyardVideoPlayer vidyardId={vidyardId} />
      </div>
    </div>
  )
}

export default Video
